<style lang="less" scoped>
  .commSearchBar {
    height: 48px;
    border-bottom: 1px solid #d1dbe5;
    box-sizing: border-box;
    position: relative;
    background: #fff;
    z-index: 2;
    .searchLine1 {
      line-height: 48px;
      height: 48px;
    }
    .label {
      line-height: 48px;
      height: 48px;
      min-width: 60px;
      display: inline-block;
      vertical-align: top;
      padding: 0 5px 0 20px;
      text-align: right;
    }
    .frameItem {
      display: inline-block;
      width: 240px;
      padding: 0 6px; //不换行多选下拉框
      .noWrap {
        .el-select__tags {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .el-input{
      vertical-align: middle;
    }
    .foldButton {
      height: 32px;
      width: 93px;
      box-sizing: border-box;
      border: 1px solid #d1dbe5;
      position: absolute;
      border-top: 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      right: 18px;
      bottom: -32px;
      background: white;
      line-height: 32px;
      cursor: pointer;
      text-align: center;
    }
    .searchLine2 {
      background: white;
      position: absolute;
      width: 100%;
      padding-top: 10px;
      .positionRelative {
        position: relative;
        border-bottom: 1px solid #d1dbe5;
        box-sizing: border-box;
        &>div {
          display: inline-block;
        }
      }
    }
  }
</style>
<template>
  <div class="commSearchBar">
    <!--折叠按钮-->
    <div class="foldButton" v-if='shortBar' @click='foldSearchBar'>
      <span>高级筛选</span>
      <i class="fa fa-angle-down"></i>
    </div>
    <div class="searchLine1">
      <template v-if="existTimeRange">
        <div class="label">时间范围：</div>
        <div class='frameItem'>
          <el-date-picker v-model="timeRange">
          </el-date-picker>
        </div>
      </template>
      <div class="label" v-if="existKeyWord && !existTimeRange">搜索：</div>
      <template v-if="existKeyWord">
        <div class='frameItem'>
          <el-input v-model="keyWord" placeholder='搜索关键字'>
            <el-button slot="append" icon="search" @click='emitSearch'></el-button>
          </el-input>
        </div>
      </template>
    </div>
    <div class="searchLine2" v-if='!shortBar'>
      <div class='positionRelative'>

        <div v-for='iselect in selectOptions'>
          <div class="label">{{iselect.title}}：</div>
          <div class='frameItem'>
            <el-select clearable :multiple='iselect.isMultiple' v-model="iselect.selected" placeholder='全部' @change='selectedChange(iselect.selected,iselect.title)' class="noWrap">
              <el-option v-for="i in iselect.options" :key='i.value' :label='i.label' :value='i.value'></el-option>
            </el-select>
          </div>
        </div>

        <div class='frameItem' v-if='!shortBar'>
          <el-button type="primary" icon="search" @click='emitSearch'>查询</el-button>
          <el-button type="text" @click='clearSearch'>清空</el-button>
        </div>
        <div class="foldButton" v-if='!shortBar' @click='foldSearchBar'>
          <span>收起</span>
          <i class="fa fa-angle-up"></i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'commSearchBar',
    props: {
      //配置时间筛选和关键字
      existTimeRange: {
        type: Boolean,
        default: true
      },
      existKeyWord: {
        type: Boolean,
        default: true
      },
      //配置单选多选下拉框
      selectOptions: {
        type: Array,
        default() {
          //默认值
          //每个下拉选择对象格式
          // {
          //     //下拉框标题
          //     title: '学年',
          //     //是否多选
          //     isMultiple: false,
          //     //选中项（单选为普通字段）
          //     selected: null,
          //     //选中项（多选为数组对象）
          //     // selected:[],
          //     //选项
          //     options: [
          //       {
          //         value: 11235,
          //         label: '选项1'
          //       },
          //       {
          //         value: 11234,
          //         label: '选项2'
          //       },
          //       {
          //         value: 112363,
          //         label: '选项3'
          //       }
          //     ]
          //   }
          return []
        }
      }
    },
    data() {
      return {
        //时间范围
        timeRange: null,
        //关键字搜索
        keyWord: '',
        shortBar: true
      }
    },

    computed: {
      newSearchData() {
        return this.selectOptions.map(o => {
          return o.selected
        })
      }
    },
    methods: {
      //单个下拉改变
      selectedChange(selected, title) {
        this.$emit('itemChange', selected, title)
      },
      //清空筛选
      clearSearch() {
        this.timeRange = null,
          this.keyWord = '',
          this.selectOptions.map(o => {
            if (o.selected instanceof Array) {
              o.selected = []
            } else {
              o.selected = null
            }
          })
        this.$emit('clear')
      },
      //发出搜索事件，传出搜索对象包含时间范围、关键字、各个下拉的选中项
      emitSearch() {
        //时间范围
        let timeRange = null
        if (this.timeRange) {
          if (this.timeRange[0] !== null) {
            timeRange = {
              start: this.timeRange[0].getTime(),
              end: this.timeRange[1].getTime()
            }
          }
        }

        //下拉选择数据
        let selecteds = this.selectOptions.map(({
          title,
          selected
        }) => {
          return {
            title,
            selected
          }
        })

        this.$emit('search', {
          //时间范围
          timeRange,
          //关键词
          keyWord: this.keyWord,
          //选中项
          selecteds
        })
      },

      //折叠搜索条
      foldSearchBar() {
        this.shortBar = !this.shortBar
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/common/commSearch.vue